import React from 'react'
import addIcon from 'assets/images/add.svg'

const Button = ({
  title,
  className = 'btn--primary',
  type = 'button',
  icon = false,
  iconPicture = null,
  action,
  disabled,
}) => {
  let _icon

  if (icon && iconPicture) {
    _icon = <img src={iconPicture} alt='' />
  } else if (icon) {
    _icon = <img src={addIcon} alt='' />
  }

  return (
    <button
      className={`btn ${className} ` + (disabled ? 'btn--disabled' : '')}
      type={type}
      onClick={action}
      disabled={disabled}>
      {_icon}
      {title}
    </button>
  )
}

export default Button
